<div class="bg-info container connect-container">
  <div class="row">
    <div class="col-sm">
      <h1 class="testGras">{{'accueil.inscription.connexion' | translate}}</h1>
      <a (click)="this.onClickConnexion()" class="btn btn-primary w-100 text-center">{{'accueil.inscription.bouton_connexion' | translate}}</a>
    </div>
  </div>
  <div class="trait"></div>
  <div class="row">
    <div class="col-sm">
      <h2 class="testGras">{{'accueil.inscription.titre_deja_inscrit' | translate}}</h2>
      <p class="paragraphe">{{'accueil.inscription.creerCompte' | translate}}</p>
      <a [href]="this.urlInscription" class="btn btn-secondary w-100 text-center">{{'accueil.inscription.bouton_inscription' | translate}}</a>
    </div>
  </div>
</div>
